import React, { Component } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import { Gemstones } from '../../utils/gemstones'

const MobileTitle = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
    font-style: italic;
  }
`

const Container = styled.div`
  position: fixed;
  top: 100px;
  right: 35px;
  @media (max-width: 768px) {
    position: relative;
    top: auto;
    right: auto;
    width: 100vw;
    clear: both;
    text-align: center;
    ul {
      li {
        display: inline-block;
        padding-left: 5px;
        padding-right: 5px;
      }
      span {
        display: none;
      }
    }
  }
  ul {
    list-style: none;
    li {
      padding-bottom: 8px;
      text-align: right;
      cursor: pointer;
      &.active {
        span {
          opacity: 1;
        }
        img {
          opacity: 1;
        }
      }
      span {
        transition: all 0.25s ease-in-out;
        opacity: 0;
        margin-right: 10px;
        font-style: italic;
      }
      img {
        width: 10px;
        opacity: 0.5;
        transition: all 0.25s ease-in-out;
      }
      &:hover {
        span, img {
          opacity: 1;
        }
      }
    }
  }
`

const GemFilter = (props) => {

    const { products, filter, collections, category } = props;

    const allTags = [];

    const { prismicgemstones } = useStaticQuery(graphql`
    query {
      prismicgemstones:
      allPrismicGem {
        edges {
          node {
            slugs
            data {
              image {
                url
                localFile {
                  absolutePath
                }
              }
              still_image {
                url
                localFile {
                  absolutePath
                }
              }
              title {
                text
              }
            }
          }
        }
      }
    }
  `);

    let allProducts;

    // Collections
    if(category !== undefined && category.length > 0) {

      allProducts = collections.edges
      .filter(({ node: collection }) => collection.handle === category)
      .map(({ node: collection }) => (
          collection.products.map((product, index) => {
            allTags.push(product.tags);
          })
        )
      )

    // Filters
    } else if(filter !== undefined && filter.length > 0) {

      allProducts = products.edges
      .filter(({ node: product }) => product.availableForSale === true)
      .filter(({ node: product }) => product.productType === filter)
      .map((item, index) => {
        allTags.push(item.node.tags);
      })

    } else {

      allProducts = products.edges
      .filter(({ node: product }) => product.availableForSale === true)
      .map((item, index) => {
        allTags.push(item.node.tags);
      })

    }

    const flattenedTags = [].concat(...allTags);
    const uniqueTags = flattenedTags.filter((el, i, a) => i === a.indexOf(el)).sort();
    const visibleTags = [];

    // Gemstones.map((gem,index) => {
    //   if(uniqueTags.includes(gem.name)) {
    //     visibleTags.push(gem);
    //   }
    // })

    prismicgemstones.edges.map((gem, index) =>  {
      if(uniqueTags.includes(gem.node.data.title.text)) {
        visibleTags.push(gem);
      }
    })

    return (
      <>
        <Container>
          <ul>
            { visibleTags.map((tag, index) => {
              return(
                <li
                  onClick={() => props.toggleGemFilter(tag.node.data.title.text)}
                  className={props.gemFilter === tag.node.data.title.text ? 'active' : ''}
                  key={index}>
                    <span>{tag.node.data.title.text}</span>
                    <img src={tag.node.data.image.url} alt={tag.node.data.title.text}/>
                </li>
              )
            })}
          </ul>
          <MobileTitle>{props.gemFilter}</MobileTitle>
        </Container>
       { props.children }
      </>
    );

}

export default GemFilter;
